<div>
  <canvas baseChart [data]="chartData" [legend]="false" [type]="chartType" [options]="chartOptions" [plugins]="plugins"></canvas>
</div>
